import React, {Component} from 'react';
import FontAwesome from 'react-fontawesome';
import fetchJsonp from 'fetch-jsonp';
import YouTube from 'react-youtube';
import { scroller } from 'react-scroll';

import ModalCarousel from './lib/ModalCarousel';
import ShareButtons from './lib/ShareButtons';

import wnycLogo from './images/wnyc.svg';
import playIcon from './images/play.svg';
import arrowIcon from './images/arrow.svg';
import signIcon from './images/sign.svg';
import voteIcon from './images/vote.svg';
import './vendor/font-awesome.min.css';
import './App.css';

const U = '4109fdd323aaac7078eadaa8f';
const ID = '0473b3d0b8';
const URL = 'https://nypublicradio.us5.list-manage.com/subscribe/post-json';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      message: '',
      showModal: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    fetch('https://api.wnyc.org/api/v1/browser_id/', {credentials: 'include'})
      .then(r => r.json())
      .then(d => this.setState({browserId: d.browser_id}));
  }

  handleChange(event) {
    this.setState({value: event.target.value});
  }

  handleSubmit(event) {
    let { value, browserId } = this.state;
    let url = `${URL}?u=${U}&id=${ID}&EMAIL=${value}&BROWSERID=${browserId}`;

    fetchJsonp(url, {jsonpCallback: 'c'}).then(response => response.json().then(data => {
      this.setState({message: data.msg});
      var noEmail  = '0 - Please enter a value';
      var singleAt = '0 - An email address must contain a single @';
      var domainInvalid = '0 - The domain portion of the email address is invalid (the portion after the @: ab)';
      if (data.msg === noEmail) {
        this.setState({ message: 'Whoops! You need to enter your email.' })
      } else if (data.msg === singleAt) {
        this.setState({ message: 'Whoops! Your email address should only contain one @' })
      } else if (data.msg === domainInvalid) {
        this.setState({ message: 'Whoops! The domain portion of the email address is invalid (the portion after the @: ab)' })
      }
    }
    ));
    event.preventDefault();
  }

  openModal(slideIndex) {
    this.setState({showModal: true, slideIndex});
  }

  closeModal() {
    let { ytEvt } = this.state;
    if (ytEvt && ytEvt.data === YouTube.PlayerState.PLAYING) {
      ytEvt.target.stopVideo();
    }
    this.setState({showModal: false});
  }

  navigate(e) {
    e.preventDefault();
    let anchor = e.target.hash.slice(1);
    scroller.scrollTo(anchor, {smooth: true});
    window.location.hash = anchor;
  }

  onPlay(video, ytEvt) {
    this.setState({ytEvt})
    if (window.dataLayer) {
      window.dataLayer.push({
        video,
        event: 'clicked__newsroom_power__video'
      });
    }
  }

  render() {
    let opts = {
      height: 600,
      width: 1066,
      playerVars: {
        showinfo: 0,
        rel: 0
      },
    };
    let events = {
      onReady: ytEvt => this.setState({ytEvt}),
      onPause: ytEvt => this.setState({ytEvt}),
    };
    let app = this;
    let sliderSettings = {
      beforeChange() {
        let { ytEvt } = app.state;
        if (ytEvt && ytEvt.data === YouTube.PlayerState.PLAYING) {
          ytEvt.target.stopVideo();
        }
      }
    }

    return (
      <div className="page">
      <ModalCarousel
       showModal={this.state.showModal}
       slide={this.state.slideIndex}
       sliderSettings={sliderSettings}
       close={this.closeModal.bind(this)}>
        <div className="Home__video">
          <h2 className="Home__video-title">How to Change a Law</h2>
          <YouTube videoId='hD1VPnF3txU' opts={opts} {...events} onPlay={this.onPlay.bind(this, 'law')} />
          <div className="Home__video-footer">
            <ShareButtons
             facebookClass="clicked__newsroom_power__video-law-facebook"
             twitterClass="clicked__newsroom_power__video-law-twitter"/>
          </div>
        </div>
        <div className="Home__video">
          <h2 className="Home__video-title">How to Run for Office</h2>
          <YouTube videoId='IpA-6rzxBt0' opts={opts} {...events} onPlay={this.onPlay.bind(this, 'office')} />
          <div className="Home__video-footer">
            <ShareButtons
             facebookClass="clicked__newsroom_power__video-office-facebook"
             twitterClass="clicked__newsroom_power__video-office-twitter"/>
          </div>
        </div>
        <div className="Home__video">
          <h2 className="Home__video-title">How to Fix a Neighborhood</h2>
          <YouTube videoId='fimhWu6W8gc' opts={opts} {...events} onPlay={this.onPlay.bind(this, 'neighborhood')} />
          <div className="Home__video-footer">
            <ShareButtons
             facebookClass="clicked__newsroom_power__video-neighborhood-facebook"
             twitterClass="clicked__newsroom_power__video-neighborhood-twitter"/>
          </div>
        </div>
        <div className="Home__video">
          <h2 className="Home__video-title">How to Count Your Vote</h2>
          <YouTube videoId='IKtbfVmKM3w' opts={opts} {...events} onPlay={this.onPlay.bind(this, 'count')} />
          <div className="Home__video-footer">
            <ShareButtons
             facebookClass="clicked__newsroom_power__video-count-facebook"
             twitterClass="clicked__newsroom_power__video-count-twitter"/>
          </div>
        </div>
        <div className="Home__video">
          <h2 className="Home__video-title">How to Work the Political Machine</h2>
          <YouTube videoId='MnI7iBxCN4A' opts={opts} {...events} onPlay={this.onPlay.bind(this, 'machine')} />
          <div className="Home__video-footer">
            <ShareButtons
             facebookClass="clicked__newsroom_power__video-machine-facebook"
             twitterClass="clicked__newsroom_power__video-machine-twitter"/>
          </div>
        </div>
        <div className="Home__video">
          <h2 className="Home__video-title">How to Be a Changemaker</h2>
          <YouTube videoId='Z4fJpPLVMds' opts={opts} {...events} onPlay={this.onPlay.bind(this, 'machine')} />
          <div className="Home__video-footer">
            <ShareButtons
             facebookClass="clicked__newsroom_power__video-machine-facebook"
             twitterClass="clicked__newsroom_power__video-machine-twitter"/>
          </div>
        </div>
        <div className="Home__video">
          <h2 className="Home__video-title">How to Challenge an Incumbent</h2>
          <YouTube videoId='cfAytJpdjig' opts={opts} {...events} onPlay={this.onPlay.bind(this, 'machine')} />
          <div className="Home__video-footer">
            <ShareButtons
             facebookClass="clicked__newsroom_power__video-machine-facebook"
             twitterClass="clicked__newsroom_power__video-machine-twitter"/>
          </div>
        </div>
      </ModalCarousel>

        <div className="background">
        <div className="box__top">
          <ShareButtons facebookClass="newsroom_power_facebook_share" twitterClass="newsroom_power_twitter_share" />
        </div>
        <div className="box__header">
          <div className="box__title">
            <div className="logo">
              <a href="https://www.wnyc.org" target="_blank" rel="noopener noreferrer" className="newsroom_power_wnyc_header"><img src={wnycLogo} alt="WNYC logo"></img></a>
            </div>
            <h2>The People's Guide to Power</h2>
            <h3>The last presidential election ignited a wave of activism across the country as ordinary people seek more of a say about the role of government in their lives. “The People’s Guide to Power” is an ongoing series from WNYC that examines how government works in our region, how people get involved — and how they sometimes get left out.</h3>
          </div>
        </div>

            <div className="nav">
              <ul>
                <li><a href="#audio" onClick={this.navigate} className="clicked__newsroom_power__jump-to-audio">Hear the power <img src={arrowIcon} alt="arrow icon"></img></a></li>
                <li><a href="#videos" onClick={this.navigate} className="clicked__newsroom_power__jump-to-video">Watch the power <img src={arrowIcon} alt="arrow icon"></img></a></li>
                <li><a href="#resources" onClick={this.navigate} className="clicked__newsroom_power__jump-to-resources">Harness the power <img src={arrowIcon} alt="arrow icon"></img></a></li>
              </ul>
            </div>

            <div id="audio" name="audio" className="anchor-link"></div>

            <div className="section">
              <h2 className="section__header">Hear the Power</h2>
              <div className="box__description">We’re telling stories from the ground up about people who need power, want power or have power, showing how they get it, how they use it and why.</div>
              <iframe className="audio-embed" frameBorder="0" scrolling="no" height="130" width="100%" src="https://www.wnyc.org/widgets/ondemand_player/wnyc/#file=/audio/json/808023/" title="embeddable player"></iframe>
              <iframe className="audio-embed" frameBorder="0" scrolling="no" height="130" width="100%" src="https://www.wnyc.org/widgets/ondemand_player/wnyc/#file=/audio/json/808024/" title="embeddable player"></iframe>
              <iframe className="audio-embed" frameBorder="0" scrolling="no" height="130" width="100%" src="https://www.wnyc.org/widgets/ondemand_player/wnyc/#file=/audio/json/808026/" title="embeddable player"></iframe>
              <iframe className="audio-embed" frameBorder="0" scrolling="no" height="130" width="100%" src="https://www.wnyc.org/widgets/ondemand_player/wnyc/#file=/audio/json/808027/" title="embeddable player"></iframe>
              <a href="http://www.wnyc.org/series/peoples-guide-power" target="_blank" rel="noopener noreferrer" className="clicked__newsroom_power__more-audio">More audio stories <img src={arrowIcon} alt="arrow icon"></img></a>
            </div>

            <div id="videos" name="videos" className="anchor-link"></div>
            <div className="section">

              <div className="wrapper text--center">
                <h2>Watch the Power</h2>
                <div className="box__description"> We’re showing you what it takes to make change, big and small, with real-life people sharing their real-life stories & tips.</div>
                <div className="grid">
                  <div className="grid__item grid__item__one" onClick={() => this.openModal(0)}>
                    <div className="grid__inner"><div className="video__title">How to Change a Law</div>
                      <img src="images/change-a-law1.jpg" alt="thumbnail" />
                      <div className="play__btn"><img src={playIcon} alt="play button" width="50px" /></div>
                    </div>
                  </div>
                  <div className="grid__item grid__item__two" onClick={() => this.openModal(1)}>
                    <div className="grid__inner"><div className="video__title">How to Run for Office</div>
                    <img src="images/run-for-office.jpg" alt="thumbnail" />
                    <div className="play__btn"><img src={playIcon} alt="play button" width="50px" /></div>
                  </div>
                  </div>
                  <div className="grid__item grid__item__three" onClick={() => this.openModal(2)}>
                    <div className="grid__inner"><div className="video__title">How to Fix Your Neighborhood</div>
                    <img src="images/fix-neighborhood.jpg" alt="thumbnail" />
                    <div className="play__btn"><img src={playIcon} alt="play button" width="50px" /></div>
                  </div>
                  </div>
                  <div className="grid__item grid__item__four" onClick={() => this.openModal(3)}>
                    <div className="grid__inner"><div className="video__title">How to Count Your Vote</div>
                    <img src="images/count-vote.jpg" alt="thumbnail" />
                    <div className="play__btn"><img src={playIcon} alt="play button" width="50px" /></div>
                  </div>
                  </div>
                  <div className="grid__item grid__item__five" onClick={() => this.openModal(4)}>
                    <div className="grid__inner"><div className="video__title">How to Work the Political Machine</div>
                    <img src="images/political-machine.jpg" alt="thumbnail" />
                    <div className="play__btn"><img src={playIcon} alt="play button" width="50px" /></div>
                  </div>
                  </div>
                  <div className="grid__item grid__item__six" onClick={() => this.openModal(5)}>
                    <div className="grid__inner"><div className="video__title">How to Be a Changemaker</div>
                    <img src="images/be-a-changemaker.jpg" alt="thumbnail" />
                    <div className="play__btn"><img src={playIcon} alt="play button" width="50px" /></div>
                  </div>
                  </div>
                  <div className="grid__item grid__item__seven" onClick={() => this.openModal(6)}>
                    <div className="grid__inner"><div className="video__title">How to Challenge an Incumbent</div>
                    <img src="images/incumbent.jpg" alt="thumbnail" />
                    <div className="play__btn"><img src={playIcon} alt="play button" width="50px" /></div>
                  </div>
                  </div>
                </div>
              </div>
            </div>

            <div id="resources" name="resources" className="anchor-link"></div>
            <div className="section resources">

                <h2>Harness the Power</h2>
                  <div className="resource__grid">
                    <div className="item"><img src={signIcon} alt="sign icon"></img><h3>Solve a Problem in Your Borough</h3><p>Use this infographic to help you know where to go to solve problems in your own borough. Find out who to approach with different concerns.</p><a href="https://media.wnyc.org/media/resources/2017/Sep/06/PGTP_SocialMediaGuide_Neighborhood-2017.pdf" download className="clicked__newsroom_power__dl-infographic">Download it now <img src={arrowIcon} alt="arrow icon"></img></a></div>
                    <div className="item"><img src={voteIcon} alt="vote icon"></img><h3>Pick a Candidate with the Voter Guide</h3><p>WNYC put together a NYC 2017 General Elections Voter Guide for NYC and NJ. Find out who will be on your ballot.</p><a href="https://wnyc.org/votenyc" target="_blank" rel="noopener noreferrer" className="clicked__newsroom_power__voter-guide">Explore the guide <img src={arrowIcon} alt="arrow icon"></img></a></div>
                  </div>

            </div>

            <div className="section big">
              <div className="box__newsletter">
                    <h3 className="text--large text--white">
                      Stay Connected to WNYC
                    </h3>

                    <div className="mailchimp-form">
                      <form onSubmit={this.handleSubmit}>
                        <label>
                          <input placeholder="Enter your email" type="email" value={this.state.value} onChange={this.handleChange}/>
                        </label>
                        <input type="submit" value="Sign up" className="clicked__newsroom_power__newsletter" />
                      </form>
                      <div className="box__newsletter--error clicked__" dangerouslySetInnerHTML={{ __html: this.state.message }}/></div>
                    </div>

                    <div className="box__social">
                      <a href="https://www.facebook.com/WNYC/" target="_blank"
                         className="link--white clicked__newsroom_power__wnyc_facebook" rel="noopener noreferrer">
                        <FontAwesome name='facebook'/>
                        Facebook
                      </a>
                      <a href="https://twitter.com/wnyc" target="_blank"
                         className="link--white clicked__newsroom_power__wnyc_twitter" rel="noopener noreferrer">
                        <FontAwesome name='twitter'/>
                        Twitter
                      </a>
                    </div>
              </div>
              <div className="section footer">
                <div className="donate">This project is listener-supported. <a href="https://pledge3.wnyc.org/donate/main/onestep/?utm_source=wnyc&utm_medium=wnyc-86x27&utm_content=wnyc-header-beta&utm_campaign=pledge" target="_blank" rel="noopener noreferrer" className="clicked__newsroom_power__donate">Donate now <img src={arrowIcon} alt="arrow icon"></img></a></div>
                See our <a href="http://www.wnyc.org/privacy/" target="_blank" rel="noopener noreferrer">privacy policy</a> and <a href="http://www.wnyc.org/terms/" target="_blank" rel="noopener noreferrer">terms of service</a>. <div>&copy; 2017 <a href="http://www.wnyc.org/" target="_blank" rel="noopener noreferrer" className="clicked__">WNYC</a></div>

              </div>
          </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js